import { IProduct } from '../components/ACustomerReviews/interfaces'
import { AxiosPromise } from 'axios'
import { client } from '.'

export interface GetProductsResponse {
  count: number
  products: IProduct[]
  pages: number
  currentPage: number
}

interface GetProductOptions {
  userId: number
  productId?: number
  page?: number
}

export function getProducts(
  options: GetProductOptions
): AxiosPromise<GetProductsResponse> {
  return client.get('/customer_product', {
    params: {
      userId: options.userId,
      productId: options.productId,
      page: options.page,
    },
  })
}

export function postReview(fd: FormData): AxiosPromise<FormData> {
  return client.post('/customer_product/post', fd, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
  })
}
